// extracted by mini-css-extract-plugin
export default {"tile":"ms-tile_tile__Xh9Fp","unknown":"ms-tile_unknown__D6BUh"};